<script setup lang="ts">
import { BLanguageSwitch } from '@/design-system';

type PropsType = {
    showLanguageSwitch?: boolean;
    showLogo?: boolean;
    logoText?: string;
    maxWidth?: string | number;
    centered?: boolean;
};

withDefaults(defineProps<PropsType>(), {
    showLanguageSwitch: true,
    showLogo: true,
    logoText: 'Buylo',
    maxWidth: 'md',
    centered: true,
});
</script>

<template>
    <VContainer style="min-width: 100%; max-height: 100vh">
        <VAppBar
            :elevation="0"
            color="transparent"
        >
            <div
                v-if="showLanguageSwitch"
                class="language-switch"
            >
                <BLanguageSwitch
                    density="default"
                    color="grey-800"
                />
            </div>
        </VAppBar>

        <div class="layout-wrapper layout-blank">
            <slot />
        </div>
    </VContainer>
</template>

<style lang="scss" scoped>
.language-switch {
    position: absolute;
    top: 10px;
    right: 10px;
}
</style>
